import React from 'react'
import { Box, Paper, Typography } from '@mui/material'
import DeviceManager from '../../components/Devices/DeviceManager'


const OrgDevices = () => {
  // We can get orgId from context or local storage
  const orgId = localStorage.getItem('org_id') // fallback

  return (
    <Box sx={{ p: { xs: 1, md: 3 } }}>
      <Paper sx={{ p: { xs: 2, md: 3 }, borderRadius: 3, bgcolor: 'background.paper', boxShadow: 3 }}>
        {/* Header */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="h4" fontWeight="bold" gutterBottom>
            Device Management
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Manage and monitor registered biometric devices for your organization
          </Typography>
        </Box>

        <DeviceManager organizationId={orgId} />
      </Paper>
    </Box>
  )
}

export default OrgDevices